import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RecalculateStockPage } from './recalculate-stock.page';

const routes: Routes = [
  {
    path: '',
    component: RecalculateStockPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RecalculateStockPageRoutingModule {}
